import { AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatButtonModule, MatButtonToggleModule,MatCheckboxModule, MatDatepickerModule,MatRadioModule, MatNativeDateModule, MatTooltipModule, MatFormFieldModule, MatInputModule } from '@angular/material';
import { MatSelectModule } from '@angular/material/select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MomentModule } from 'angular2-moment';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { RecaptchaModule, RecaptchaSettings, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { ChartsModule } from 'ng2-charts';
import { CookieService } from 'ngx-cookie-service';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { NgxImageCompressService } from 'ngx-image-compress';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TagsInputModule } from 'ngx-tags-input/dist';
import { AppLinksComponent } from './app-links/app.links.component';
import { AppComponent } from './app.component';
import { AuthService } from './auth/auth.service';
import { HttpInterceptorService } from './auth/http-interceptor.service';
import {AsstesService} from './assets/asstes.service';
import { MeService } from './auth/me.service';
import { AzureComponent } from './azure/azure.component';
import { CapabilityEngineService } from './capabilityEngine.service';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { changePasswordService } from './change-password/change-password.service';
import { Constants } from './constants';
import { Dashboard2Component } from './dashboard2/dashboard.component';
import { Dashboard2Service } from './dashboard2/dashboard.service';
import { DeleteImageComponent } from './delete-image/delete-image.component';
import { DeviceDetectorComponent } from './device-detector/device-detector.component';
import { DeviceDetectorService } from './device-detector/device-detector.service';
import { DisableLinkDirective } from './disable.directive';
import { ErrorFieldDisplayComponent } from './error-field-display.component';
import { FixedHazardFormComponent } from './fixed-hazard-form/fixed-hazard-form.component';
import { FixedHazardService } from './fixed-hazard-form/fixed-hazard.service';
import { ForceUpdateComponent } from './force-update/force-update.component';
import { ForceUpdateService } from './force-update/force-update.service';
import { ForcelogoutExistingsessionComponent } from './forcelogout-existingsession/forcelogout-existingsession.component';
import { ForcelogoutExistingsessionService } from './forcelogout-existingsession/forcelogout-existingsession.service';
import { FormsListComponent } from './forms-list/forms-list.component';
import { FormsListService } from './forms-list/forms-list.service';
import { FormsPreviewComponent } from './forms-preview/forms-preview.component';
import { FormsPreviewService } from './forms-preview/forms-preview.service';
import { HazardFormListFilterComponent } from './hazard-form-filter/hazard-form-filter.component';
import { HazardFormFilterService } from './hazard-form-filter/hazard-form-filter.service';
import { HazardsComponent } from './hazards/hazards.component';
import { HazardsService } from './hazards/hazards.service';
import { LandingComponent } from './landing/landing.component';
import { LandingService } from './landing/landing.service';
import { MissingCapabilityComponent } from './missing-capability/missing-capability.component';
import { MissingCapabilityService } from './missing-capability/missing-capability.service';
import { NewTeamComponent } from './new-team/new-team.component';
import { NewTeamService } from './new-team/new-team.service';
import { NewUserComponent } from './new-user/new-user.component';
import { NewUserService } from './new-user/new-user.service';
import { NotificationDetailsComponent } from './notification-details/notification-details.component';
import { NotificationDetailsService } from './notification-details/notification-detatils.service';
import { NotificationsComponent } from './notifications/notifications.component';
import { NotificationsService } from './notifications/notifications.service';
import { OnboardingConfirmationComponent } from './onboarding-confirmation/onboarding-confirmation.component';
import { OnboardingConfirmationService } from './onboarding-confirmation/onboarding-confirmation.service';
import { OnboardingScreenComponent } from './onboarding-screen/onboarding-screen.component';
import { OnboardingScreenService } from './onboarding-screen/onboarding-screen.service';
import { PasswordSuccessfulComponent } from './password-successful/password-successful.component';
import { PasswordSuccessfulService } from './password-successful/password-successful.service';
import { PaymentService } from './payment.service';
import { FilterPipe } from './pipes/filter.pipe';
import { SafeHtmlPipe } from './pipes/safehtml.pipe';
import { SortPipe } from './pipes/sort.pipe';
import { RedirectComponent } from './redirect/redirect.component';
import { RedirectService } from './redirect/redirect.service';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ResetPasswordService } from './reset-password/reset-password.service';
import { RestrictMobileComponent } from './restrict-mobile/restrict-mobile.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { ScheduleService } from './schedule/schedule.service';
import { LoaderService } from './shared/loader.service';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignInService } from './sign-in/sign-in.service';
import { StartTourComponent } from './start-tour/start-tour.component';
import { SubmittedFormListFilterComponent } from './submitted-form-filter/submitted-form-filter.component';
import { SubmittedFormFilterService } from './submitted-form-filter/submitted-form-filter.service';
import { SubmittedFormListComponent } from './submitted-form-list/submitted-form-list.component';
import { SubmittedFormListService } from './submitted-form-list/submitted-forms-list.service';
import { SubmittedFormPreviewComponent } from './submitted-form-preview/submitted-form-preview.component';
import { SubmittedFormPreviewService } from './submitted-form-preview/submitted-form-preview.service';
import { SubmittedFormsComponent } from './submitted-forms/submitted-forms.component';
import { SubmittedFormsService } from './submitted-forms/submitted-forms.service';
import { SwitchMessageComponent } from './switch-message/switch-message.component';
import { CustomMessageComponent } from './custom-message/custom-message.component';
import { TeamDetailsComponent } from './team-details/team-details.component';
import { TeamDetailsService } from './team-details/team-details.service';
import { TeamProfileComponent } from './team-profile/team-profile.component';
import { TeamProfileService } from './team-profile/team-profile.service';
import { TeamSelectionComponent } from './team-selection/team-selection.component';
import { TeamSelectionService } from './team-selection/team-selection.service';
import { TeamsListComponent } from './teams-list/teams-list.component';
import { TeamsListService } from './teams-list/teams-list.service';
import { UserGuideComponent } from './user-guide/user-guide.component';
import { UserGuideService } from './user-guide/user-guide.service';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UserProfileService } from './user-profile/user-profile.service';
import { UserRoleDegradeComponent } from './user-role-degrade/user-role-degrade.component';
import { UserRoleDegradeService } from './user-role-degrade/user-role-degrade.service';
import { UsersListComponent } from './users-list/users-list.component';
import { UsersListService } from './users-list/users-list.service';
import { VerifyAccountComponent } from './verify-account/verify-account.component';
import { VerifyAccountService } from './verify-account/verify-account.service';
import { WebPaymentsComponent } from './web-payments/web-payments.component';
import { WelcomeScreenComponent } from './welcome-screen/welcome-screen.component';
import { Form } from './rFF/form/form.component';
import { SubFormComponent } from './rFF/sub-form/sub-form.component';
import { shortTextComponent } from './rFF/fields/short-text/short-text.component';
import { longTextComponent } from './rFF/fields/longtext/long-text.component';
import { SectionComponent } from './rFF/section/section.component';
import { PageComponent } from './rFF/page/page.component';
import { FieldDirective } from './rFF/directives/field.directive';
import { SectionDirective } from './rFF/directives/section.directive';
import { ImagePickerComponent } from './rFF/fields/imagePicker/imagePicker.component';
import { HazardComponent } from './rFF/fields/hazard/hazard.component';
import { ActionComponent } from './rFF/fields/action/action.component';
import { FormFieldComponent } from './rFF/fields/form-field/form-field.component';
import { DatePickerComponent } from './rFF/fields/date-picker/date-picker.component';
import { ReadTextComponent } from './rFF/fields/read-text/read-text.component';
import { NumberFieldComponent } from './rFF/fields/number-field/number-field.component';
import { TimePickerComponent } from './rFF/fields/time-picker/time-picker.component';
import { CheckBoxComponent } from './rFF/fields/check-box/check-box.component';
import { LocationComponent } from './rFF/fields/location/location.component';
import { SignatureComponent } from './rFF/fields/signature/signature.component';
import { BulkGroupComponent } from './rFF/fields/bulk-group/bulk-group.component';
import { MultiChoiceComponent } from './rFF/fields/multi-choice/multi-choice.component';
import { HazardWithLabelComponent } from './rFF/fields/hazard-with-label/hazard-with-label.component';
import { GroupQuestionComponent } from './rFF/fields/group-question/group-question.component';
import { MultiChoiceListComponent } from './rFF/fields/multi-choice-list/multi-choice-list.component';
import { CheckBoxListComponent } from './rFF/fields/check-box-list/check-box-list.component';
import { UserListComponent } from './rFF/fields/user-list/user-list.component';
import { WorkOrderIdComponent } from './rFF/fields/work-order-id/work-order-id';
import { ActionWorkOrderIdComponent } from './rFF/fields/action-work-order-id/work-order-id';
import { KeysPipe } from './rFF/pipes/keys.pipe';
import { ParserService } from './rFF/services/parser.service';
import { PreParserService } from './rFF/services/pre-parser.service';
import { ValidationService } from './rFF/services/validation.service';
import { StyleService } from './rFF/services/style.service';
import { FormService } from './rFF/form/form.service';
import { RFFConstants } from './rFF/constants';
import { MultiChoiceListPipe } from './rFF/pipes/multi-choice-list.pipe';
import { LocalDBService } from './local-db.service';
import { SectiontitleComponent } from './rFF/fields/sectiontitle/sectiontitle.component';
import { FreeFormDrawComponent } from './rFF/fields/free-form-draw/free-form-draw.component';
import { CanvasComponent } from './rFF/canvas/canvas.component';
import { UrlComponent } from './rFF/fields/url/url.component';
import { DeleteAssetListComponent } from './delete-asset-list/delete-asset-list.component';
import { PdfFieldComponent } from './rFF/fields/pdf-field/pdf-field.component';
import { PdfImagePreviewComponent } from './rFF/pdf-image-preview/pdf-image-preview.component';
import { AssetsComponent } from './assets/assets.component';
import { SignatureCanvasComponent } from './rFF/signature-canvas/signature-canvas.component';
import { GlobalService } from './global.service';
import { PageDirective } from './rFF/directives/page.directive';
import { QRCodeModule } from 'angularx-qrcode';
import { CreateFolderComponent } from './create-folder/create-folder.component';
import { ImagePreviewComponent } from './image-preview/image-preview.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { ApiDocComponent } from './api-doc/api-doc.component';
import { IncidentsComponent } from './incidents/incidents.component';
import { IncidentFormsComponent } from './incident-forms/incident-forms.component';
import { IncidentService } from './incidents/incidents.service';
import { IncidentFormsService } from './incident-forms/incident-forms.service';
import { IncidentsListComponent } from './rFF/fields/incidents-list/incidents-list.component';
import { IncidentsFormsService } from './rFF/services/incidents-forms.service';
import { UserInspectionStatsComponent } from './user-inspection-stats/user-inspection-stats.component';
import { MatDialogModule } from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import { MultiChoiceTemplateComponent } from './rFF/fields/multi-choice-template/multi-choice-template.component';
import { RatingComponent } from './rFF/fields/rating/rating.component';
import { MultipleSchedulerComponent } from './multiple-scheduler/multiple-scheduler.component';
import { FixActionFormComponent } from './fix-action-form/fix-action-form.component';
import { FixActionService } from './fix-action-form/fix-action.service';
import { MoveTemplatesComponent } from './move-templates/move-templates.component';
import { AssignUsersToHazardComponent } from './assign-users-to-hazard/assign-users-to-hazard.component';
import { MatChipsModule } from '@angular/material/chips'
import { InspectionQuestionComponent } from './rFF/fields/Inspection-question/inspection-question.component';
import { FilePickerComponent } from './rFF/fields/file/file.component';

const routes: Routes = [
    {
        path: 'signUp',
        component: OnboardingScreenComponent,
        data: { onlyWeb: true },
    },
    {
        path: 'starttour',
        component: StartTourComponent,
    },
    {
        path: 'signin',
        component: SignInComponent,
        data: { onlyWeb: true },
    },
    {
        path: 'welcomescreen',
        component: WelcomeScreenComponent,
    },
    {
        path : 'signatureCanvas',
        component : SignatureCanvasComponent
    },
    {
        path: 'restrictMobile',
        data: { currentPage: 'restrictMobile' },
        component: RestrictMobileComponent
    },
    {
        path: 'signUpConfirmation',
        component: OnboardingConfirmationComponent,
        data: { onlyWeb: true },
    },
    {
        path: 'changepassword',
        component: ChangePasswordComponent
    },
    {
        path: '',
        component: LandingComponent,
        canActivate: [AuthService, MeService],
        children: [
            {
                path: '',
                component: RedirectComponent
            },
            {
                path: 'dashboard',
                data: { currentPage: 'dashboard' },
                component: Dashboard2Component
            },
            {
                path: 'usersList',
                data: { currentPage: 'users', capabilities: ['viewUserList'] },
                component: UsersListComponent
            },
            {
                path: 'newUser',
                data: { currentPage: 'users', capabilities: ['onboardUser'] },
                component: NewUserComponent
            },
            {
                path: 'teamsList',
                data: { currentPage: 'teams', capabilities: ['viewTeamList'] },
                component: TeamsListComponent
            },
            {
                path: 'newTeam',
                data: { currentPage: 'teams', capabilities: ['onboardTeam'] },
                component: NewTeamComponent
            },
            {
                path: 'teamDetails/:id',
                data: {
                    currentPage: 'teams',
                    capabilities: ['viewTeamDetails']
                },
                component: TeamDetailsComponent
            },
            {
                path: 'submittedForms',
                data: {
                    currentPage: 'submittedForms',
                    capabilities: ['viewTaskList']
                },
                component: SubmittedFormsComponent
            },
            {
                path: 'submittedFormPreview/:id',
                data: {
                    currentPage: 'submittedForms',
                    capabilities: ['viewTaskDetails']
                },
                component: SubmittedFormPreviewComponent
            },
            {
                path: 'submittedFormList/:id',
                data: {
                    currentPage: 'submittedForms',
                    capabilities: ['viewTeamDetails']
                },
                component: SubmittedFormListComponent
            },
            {
                path: 'hazards/:id',
                data: {
                    currentPage: 'hazards',
                    capabilities: ['viewTeamDetails']
                },
                component: SubmittedFormListComponent
            },
            {
                path: 'hazardform/:id',
                data: {
                    currentPage: 'hazards',
                    capabilities: ['viewTaskDetails']
                },
                component: FixedHazardFormComponent
            },
            {
                path: 'form/:id',
                data: {
                    currentPage: 'actions',
                    capabilities: ['viewTaskDetails']
                },
                component: FixActionFormComponent
            },
            {
                path: 'actions/:id',
                data: {
                    currentPage: 'actions',
                    capabilities: ['viewTaskDetails']
                },
                component: SubmittedFormListComponent
            },
            {
                path: 'incidentForms',
                data: {
                    currentPage: 'incidentForms',
                    capabilities: ['viewIncidentList']
                },
                component: IncidentFormsComponent
            },
            {
                path: 'incidents/:formId',
                data: {
                    currentPage: 'incidentForms',
                    capabilities: ['viewIncidentList']
                },
                component: IncidentsComponent
            },
            {
                path: 'assets',
                data: {
                    currentPage: 'assets',
                },
                component: AssetsComponent,
            },
            {
                path: 'formsList',
                data: {
                    currentPage: 'forms',
                    capabilities: ['viewTaskTemplateList']
                },
                component: FormsListComponent
            },
            {
                path: 'schedule',
                data: {
                    currentPage: 'schedule',
                },
                component: ScheduleComponent
            },
            {
                path: 'formPreview/:id',
                data: {
                    currentPage: 'forms',
                    capabilities: ['viewTaskTemplateDetails']
                },
                component: FormsPreviewComponent
            },
            {
                path: 'forceUpdate',
                data: { currentPage: 'update', capabilities: ['forceUpdate'] },
                component: ForceUpdateComponent
            },
            {
                path: 'azure',
                component: AzureComponent
            },
            {
                path: 'notifications',
                data: { currentPage: 'notifications' },
                component: NotificationsComponent
            },
            {
                path: 'notificationDetails',
                data: { currentPage: 'notifications' },
                component: NotificationDetailsComponent

            },
            {
                path: 'submittedFormFilter',
                data: { currentPage: 'submittedFormFilter' },
                component: SubmittedFormListFilterComponent
            },
            {
                path: 'hazardFormFilter',
                data: { currentPage: 'hazardFormFilter' },
                component: HazardFormListFilterComponent
            },
            {
                path: 'formFilling/:id',
                data: { currentPage: 'submittedForms' },
                component: Form
            },
            {
                path: 'switchTeamFilter',
                data: { currentPage: 'switchTeamFilter' },
                component: SwitchMessageComponent
            },
            {
                path: 'customMessage',
                data: { currentPage: 'customMessage' },
                component: CustomMessageComponent
            },
            {
                path: 'deletImage',
                data: { currentPage: 'deletImage' },
                component: DeleteImageComponent
            },
            {
                path: 'deviceDetector',
                data: { currentPage: 'deviceDetector' },
                component: DeviceDetectorComponent
            },
            {
                path: 'teamprofile',
                data: {
                    currentPage: 'teamprofile',
                    // capabilities: ['viewTeamDetails']
                },
                component: TeamProfileComponent
            },


        ]
    },
    {
        path: 'teamsSelection',
        data: { currentPage: 'teamsSelection' },
        component: TeamSelectionComponent
    },
    {
        path: 'verify',
        component: VerifyAccountComponent
    },
    {
        path: 'resetPassword',
        component: ResetPasswordComponent
    },
    {
        path: 'appLinks',
        data: { currentPage: 'appLinks' },
        component: AppLinksComponent
    },
    {
        path: 'userGuide',
        canActivate: [AuthService, MeService],
        component: UserGuideComponent
    },
    {
        path: 'api-doc',
        canActivate: [],
        component: ApiDocComponent
    },
    {
        path: 'webPayment',
        component: WebPaymentsComponent
    },
    {
        path: '**',
        // redirectTo: 'dashboard',
        component: RedirectComponent
    }
];

@NgModule({
    declarations: [
        RedirectComponent,
        ErrorFieldDisplayComponent,
        AppComponent,
        NewUserComponent,
        LandingComponent,
        UsersListComponent,
        TeamsListComponent,
        NewTeamComponent,
        TeamDetailsComponent,
        SubmittedFormsComponent,
        FormsPreviewComponent,
        FilterPipe,
        SortPipe,
        SafeHtmlPipe,
        FormsListComponent,
        Dashboard2Component,
        VerifyAccountComponent,
        ForceUpdateComponent,
        AzureComponent,
        SubmittedFormPreviewComponent,
        DisableLinkDirective,
        MissingCapabilityComponent,
        SubmittedFormListComponent,
        HazardsComponent,
        NotificationsComponent,
        NotificationDetailsComponent,
        AppLinksComponent,
        ResetPasswordComponent,
        TeamSelectionComponent,
        OnboardingScreenComponent,
        OnboardingConfirmationComponent,
        SubmittedFormListFilterComponent,
        HazardFormListFilterComponent,
        UserGuideComponent,
        SwitchMessageComponent,
        CustomMessageComponent,
        DeviceDetectorComponent,
        RestrictMobileComponent,
        ChangePasswordComponent,
        ForcelogoutExistingsessionComponent,
        PasswordSuccessfulComponent,
        StartTourComponent,
        WelcomeScreenComponent,
        SignInComponent,
        UserProfileComponent,
        UserRoleDegradeComponent,
        WebPaymentsComponent,
        TeamProfileComponent,
        FixedHazardFormComponent,
        FixActionFormComponent,
        ScheduleComponent,
        DeleteImageComponent,
        Form,
        shortTextComponent,
        FieldDirective,
        ImagePickerComponent,
        SectionDirective,
        SectionComponent,
        PageComponent,
        HazardComponent,
        ActionComponent,
        FormFieldComponent,
        DatePickerComponent,
        longTextComponent,
        ReadTextComponent,
        NumberFieldComponent,
        TimePickerComponent,
        CheckBoxComponent,
        LocationComponent,
        SignatureComponent,
        BulkGroupComponent,
        MultiChoiceComponent,
        HazardWithLabelComponent,
        GroupQuestionComponent,
        MultiChoiceListComponent,
        CheckBoxListComponent,
        UserListComponent,
        SubFormComponent,
        WorkOrderIdComponent,
        ActionWorkOrderIdComponent,
        KeysPipe,
        MultiChoiceListPipe,
        SectiontitleComponent,
        FreeFormDrawComponent,
        CanvasComponent,
        UrlComponent,
        DeleteAssetListComponent,
        PdfFieldComponent,
        PdfImagePreviewComponent,
        AssetsComponent,
        SignatureCanvasComponent,
        GlobalService,
        PageDirective,
        CreateFolderComponent,
        ImagePreviewComponent,
        ApiDocComponent,
        IncidentsComponent,
        IncidentFormsComponent,
        IncidentsListComponent,
        UserInspectionStatsComponent,
        MultiChoiceTemplateComponent,
        RatingComponent,
        MultipleSchedulerComponent,
        MoveTemplatesComponent,
        AssignUsersToHazardComponent,
        InspectionQuestionComponent,
        FilePickerComponent
    ],
    entryComponents: [DeviceDetectorComponent, PasswordSuccessfulComponent, ForcelogoutExistingsessionComponent, UserProfileComponent, UserRoleDegradeComponent, DeleteImageComponent, shortTextComponent, ImagePickerComponent, SectionComponent, PageComponent, HazardComponent, ActionComponent, DatePickerComponent, longTextComponent, ReadTextComponent, NumberFieldComponent, TimePickerComponent, CheckBoxComponent, LocationComponent, SignatureComponent, BulkGroupComponent, MultiChoiceComponent, HazardWithLabelComponent, GroupQuestionComponent, MultiChoiceListComponent, CheckBoxListComponent, UserListComponent, SubFormComponent, WorkOrderIdComponent, ActionWorkOrderIdComponent,SectiontitleComponent,FreeFormDrawComponent,UrlComponent,DeleteAssetListComponent,PdfFieldComponent,PdfImagePreviewComponent,FormFieldComponent,CreateFolderComponent,ImagePreviewComponent,IncidentsListComponent, UserInspectionStatsComponent, MultiChoiceTemplateComponent, RatingComponent, MultipleSchedulerComponent, MoveTemplatesComponent, AssignUsersToHazardComponent, InspectionQuestionComponent, FilePickerComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyDWfWwJQeBHeLd2lNdSF7gcf4pO3M1Y9Cc'
        }),
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatSelectModule,
        MatRadioModule,
        MatButtonToggleModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatCheckboxModule,
        InfiniteScrollModule,
        MomentModule,
        ChartsModule,
        NgxChartsModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        TagsInputModule.forRoot(),
        NgbModule.forRoot(),
        NgMultiSelectDropDownModule.forRoot(),
        DeviceDetectorModule.forRoot(),
        [RouterModule.forRoot(routes, { useHash: true })],
        QRCodeModule,
        AngularMultiSelectModule,
        MatDialogModule,
        MatExpansionModule,
        MatIconModule,
        MatTooltipModule,
        MatFormFieldModule, 
        MatInputModule,
        MatChipsModule
    ],
    providers: [
        RedirectService,
        UsersListService,
        CookieService,
        AuthService,
        MeService,
        NewUserService,
        FormsListService,
        SubmittedFormsService,
        TeamsListService,
        NewTeamService,
        VerifyAccountService,
        FormsPreviewService,
        TeamDetailsService,
        ForceUpdateService,
        SubmittedFormPreviewService,
        LoaderService,
        CapabilityEngineService,
        PaymentService,
        LandingService,
        MissingCapabilityService,
        SubmittedFormListService,
        Dashboard2Service,
        HazardsService,
        FixActionService,
        NotificationsService,
        NotificationDetailsService,
        ResetPasswordService,
        TeamSelectionService,
        SubmittedFormFilterService,
        HazardFormFilterService,
        UserGuideService,
        Constants,
        DeviceDetectorService,
        OnboardingConfirmationService,
        OnboardingScreenService,
        changePasswordService,
        ForcelogoutExistingsessionService,
        PasswordSuccessfulService,
        SignInService,
        UserProfileService,
        UserRoleDegradeService,
        TeamProfileService,
        GoogleMapsAPIWrapper,
        FixedHazardService,
        NgxImageCompressService,
        ScheduleService,
        ParserService,
        PreParserService,
        ValidationService,
        StyleService,
        FormService,
        RFFConstants,
        LocalDBService,
        AsstesService,
        IncidentService,
        IncidentFormsService,
        IncidentsFormsService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorService,
            multi: true
        },
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: {
                siteKey: 'RECAPTCHA_SITE_KEY'
            } as RecaptchaSettings
        }
    ],
    bootstrap: [AppComponent],
    exports:[MultiChoiceListComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts